import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Because HostJane is a middle woman, it's safer dealing through her. She holds the Buyer's cash long enough to make sure they get what they paid for.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      